// extracted by mini-css-extract-plugin
module.exports = {"degreeLevelTypesContainer":"degreeLevelTypes_degreeLevelTypesContainer__4ksgr","salaryDemographicChart":"degreeLevelTypes_salaryDemographicChart___xAlY"};